import { Text } from '@naf/text';
import { spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const FAQWrapper = styled.div`
  margin-top: ${spacing.space24};
`;

export const FAQTitle = styled(Text)`
  margin-bottom: ${spacing.space16} !important;
`;

export const AccordionContent = styled.div`
  p {
    margin: 0;
  }

  p:not(:last-child) {
    margin-bottom: ${spacing.space16};
  }
`;

export const BodyContentWrapper = styled.div`
  margin-top: ${spacing.space32};
`;
